import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { NuInput } from './Input';
import { CancelButton, SubmitButton } from './Buttons';
import axiosInstance from '../../Services/axiosCommon';
import { useToast } from '../Others/ToastServices';

const EmailModal = ({ onClose, idd, fetcher, eUrl }) => {
  const [newEmail, setNewEmail] = useState('');
  const [newCcEmail, setNewCcEmail] = useState('');
  const toast = useToast();
  const [loading, setLoading] = useState(false);
const [emailError, setEmailError] = useState('');
const [ccEmailError, setCcEmailError] = useState('');

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: { to: [], cc: [] },
    validationSchema: yup.object({
    to: yup.array().min(1, 'At least one recipient email is required.'),
    // cc: yup.array(),
  }),
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);
      const payload = {
        ...values,
        to: Array.isArray(values.to) ? values.to : [values.to],
      };

      axiosInstance.post(`${eUrl}email-report/${idd}`, payload)
        .then((res) => {
          toast.open({
            type: res.data?.status ? 'success' : 'error',
            message: res.data?.status ? 'Success' : 'Error',
            description: res.data?.msg || res.data?.error || 'Email send status unknown.',
          });
          if (res.data?.status) {
            resetForm();
            fetcher();
            onClose();
          }
        })
        .catch(() => {
          toast.open({ type: 'error', message: 'Error', description: 'Network error.' });
        })
        .finally(() => setLoading(false));
    },
  });

  const handleAddEmail = (field, email, setter) => {
  if (!email) return;

  if (formik.values[field].includes(email)) {
    toast.open({
      type: 'error',
      message: 'Already Exist Email',
      description: `${email} already exists in ${field.toUpperCase()}.`,
    });
    return;
  }

  formik.setFieldValue(field, [...formik.values[field], email]);
  setter('');
};


  const handleRemoveEmail = (field, email) => {
    formik.setFieldValue(
      field,
      formik.values[field].filter((e) => e !== email)
    );
  };

  return (
    <div className="animate-scale-in w-full max-w-md max-h-[80vh] overflow-y-auto p-4 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100">
      {/* <h2 className="text-lg text-center font-semibold mb-4">Send Email</h2> */}

      <form onSubmit={formik.handleSubmit}>
        {/* To Section */}
        <div className="mb-6">
          <div className="flex items-center gap-2">
          <label className="block text-sm font-semibold text-gray-700 mb-2">To:</label>

            <NuInput
              type="email"
              placeholder="Add recipient email"
              value={newEmail}
              onChange={(e) => setNewEmail(e.target.value)}
              width="w-full"
            />
            <button
              type="button"
              onClick={() => handleAddEmail('to', newEmail, setNewEmail)}
              className="px-2 py-1 text-xs bg-baseColor-primary text-white rounded "
            >
              +
            </button>
          </div>
          {formik.touched.to && formik.errors.to && (
  <p className="text-red-500 text-xs ">{formik.errors.to}</p>
)}

          {formik.values.to.length > 0 && (
            <div className="mt-3 bg-gray-100 border rounded p-2 max-h-32 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400">
              {formik.values.to.map((email, idx) => (
                <div
                  key={`to-${idx}`}
                  className="flex items-center justify-between bg-white border rounded px-3 py-1 mb-1 text-sm"
                >
                  <span>{email}</span>
                  <button
                    type="button"
                    onClick={() => handleRemoveEmail('to', email)}
                    className="text-red-500 hover:text-red-700"
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* CC Section */}
        <div className="mb-6">
          <div className="flex items-center gap-2">
          <label className="block text-sm font-semibold text-gray-700 mb-2">CC:</label>

            <NuInput
              type="email"
              placeholder="Add CC email"
              value={newCcEmail}
              onChange={(e) => setNewCcEmail(e.target.value)}
              width="w-full"
            />
            <button
              type="button"
              onClick={() => handleAddEmail('cc', newCcEmail, setNewCcEmail)}
              className="px-2 py-1 text-xs bg-baseColor-primary text-white rounded "
            >
              +
            </button>
          </div>
          {formik.values.cc.length > 0 && (
            <div className="mt-3 bg-gray-100 border rounded p-2 max-h-32 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400">
              {formik.values.cc.map((email, idx) => (
                <div
                  key={`cc-${idx}`}
                  className="flex items-center justify-between bg-white border rounded px-3 py-1 mb-1 text-sm"
                >
                  <span>{email}</span>
                  <button
                    type="button"
                    onClick={() => handleRemoveEmail('cc', email)}
                    className="text-red-500 hover:text-red-700"
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end gap-3 mt-6">
          <CancelButton handleClick={onClose} />
          <SubmitButton 
            name="Send"
            type="submit"
            isLoading={loading}
            disabled={formik.values.to.length === 0}
          />
        </div>
      </form>
    </div>
  );
};

export default EmailModal;
